import React, { useState, useMemo } from 'react';
import Table from '../../components/Table';
import { useNavigate } from 'react-router-dom'
import moment from 'moment';
import api from '../../api/api';
import { saveAs } from 'file-saver';

export default function RepairsTable() {
    const urlEndingRepairsTable = '/PropertiesRepairsMetric';
    const urlEndingAuditTable = '/PropertiesAuditsMetric';
    const navigate = useNavigate()

    const [downloadingAuditId, setDownloadingAuditId] = useState(null);

    const callback = (value, index, data) => {
        data = data[index];
    };

    const handleDownloadReport = async (auditId) => {
        setDownloadingAuditId(auditId);
        try {
            const token = localStorage.getItem("token");
            const res = await api.getAuditReport(token, auditId);
            const data = res.data;
            if (data && data.File) {
                const byteCharacters = atob(data.File);
                const byteNumbers = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const blob = new Blob([byteNumbers], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `${data.Subject}.xlsx`);
            } else {
                console.log('No file found in response:', data);
            }
        } catch (error) {
            console.log('Error downloading the report:', error);
        } finally {
            setDownloadingAuditId(null);
        }
    }

    const auditTableColumns = useMemo(() => [
        {
            Header: 'Property Name',
            accessor: 'PropertyName'
        },
        {
            Header: 'Audit Date',
            accessor: 'SubmitDate',
            Cell: ({ value }) => {
                if (!value) return '';
                return <div>{moment(value).format("MM/DD/YYYY")}</div>;
            }
        },
        {
            Header: 'Link to Audit',
            accessor: 'AuditId',
            Cell: ({ value }) => {
                return value ? <div className='buttons-wrapper table-center-field'>
                    <button className='rr-btn rr-delete-btn' onClick={() => navigate(`/audit-nav/${value}`)}>AUDIT DETAILS</button></div> : "";
            }
        },
        {
            Header: 'Download Report',
            accessor: 'downloadReport',
            Cell: ({ row }) => {
                const auditId = row.original.AuditId;
                const isDownloading = downloadingAuditId === auditId;
                return auditId
                    ? <div className='table-center-field buttons-wrapper'>
                        <button className={isDownloading ? 'rr-btn rr-loading-btn' : 'rr-btn rr-delete-btn'} onClick={() => handleDownloadReport(auditId)} disabled={isDownloading}>{isDownloading ? "DOWNLOADING..." : "DOWNLOAD REPORT"}</button></div>
                    : "";
            }
        }
    ])

    const columns = useMemo(() => [
        {
            Header: 'Property Name',
            accessor: 'PropertyName'
        },
        {
            Header: 'City',
            accessor: 'City'
        },
        {
            Header: 'State',
            accessor: 'State'
        },
        {
            Header: 'Number Of Repairs',
            accessor: 'NumberOfRepairs',
            Cell: ({ row: { index }, value }) => <div>{value}</div>
        },
    ]);

    return (
        <>
            <div className='table-container-ws table-container-rr'>
                <Table columns={columns} url={urlEndingRepairsTable} callback={callback} />
            </div>
            <div className='table-container-ws table-container-rr'>
                <Table columns={auditTableColumns} url={urlEndingAuditTable} callback={callback} />
            </div>

        </>
    );
}
